import cliente from './cliente'
import empresa from './empresa'
import funcionalidade from './funcionalidade'
import modulo from './modulo'
import municipio from './municipio'
import notaVersao from './nota-versao'
import ramoAtividade from './ramo-atividade'
import sistema from './sistema'
import usuario from './usuario'

export default baseUrl => {
    baseUrl = `${baseUrl}/cadastro`

    return {
        cliente: cliente(baseUrl),
        empresa: empresa(baseUrl),
        funcionalidade: funcionalidade(baseUrl),
        modulo: modulo(baseUrl),
        municipio: municipio(baseUrl),
        notaVersao: notaVersao(baseUrl),
        ramoAtividade: ramoAtividade(baseUrl),
        sistema: sistema(baseUrl),
        usuario: usuario(baseUrl),
    }
}